import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  Index2tzg8vllut89f as Index,
  Denormalized13y861o5nekmb as Denormalized,
  Description1f0zycfwk0zld as Description,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
  AdminViewOnlyyhkyako4fc99 as AdminViewOnly,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Companion_getInstance1exe5oe9i5w84 as Companion_getInstance,
  Type_PartFull_getInstance1qsztgbc7u19t as Type_PartFull_getInstance,
} from './attendance.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  $serializer_getInstance1dhvc4iof5db1 as $serializer_getInstance,
  ID1z61wlmtvxrjn as ID,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance_0,
  ID1m87d1hextx54 as ID_0,
  ID__toString_impl_y5caka34b933o3jkvt9 as ID__toString_impl_y5caka,
  ID__toString_impl_y5caka917l9wj8qah0 as ID__toString_impl_y5caka_0,
  ID__hashCode_impl_f4lulz3s4hpwy6rxg06 as ID__hashCode_impl_f4lulz,
  ID__hashCode_impl_f4lulz1y71t598eu6qn as ID__hashCode_impl_f4lulz_0,
} from './domain.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { DatePeriodSerializer_getInstance41w3hzzadrlu as DatePeriodSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/DateTimePeriodSerializers.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { $serializer_getInstancegx2p6odi22tj as $serializer_getInstance_1 } from './types.mjs';
import {
  $serializer_getInstance33z4kgxgrgb0n as $serializer_getInstance_2,
  Cents1lsbs5l1tlgw as Cents,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
} from '../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareLocationProgram.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareLocationProgram())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_tuxk26_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tuxk26_k$(encoder, value instanceof ID_1() ? value.raw_1 : THROW_CCE());
      }
      deserialize_y2vm1l_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_1())(this.deserialize_y2vm1l_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_3() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz_1($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_1()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_1())(other instanceof ID_1() ? other.raw_1 : THROW_CCE()));
}
function CareLocationProgram$Companion$$childSerializers$_anonymous__8i65p0() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var IDClass;
function ID_1() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_1(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_3});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, null, lazy(tmp_0, CareLocationProgram$Companion$$childSerializers$_anonymous__8i65p0), null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareLocationProgram', this, 11);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The rate\'s name as providers know it, e.g. "Infant" or "After School". Shown on the placement sheet.'));
        tmp0_serialDesc.addElement_5pzumi_k$('template', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The template whose rates this program is paid at.'));
        tmp0_serialDesc.addElement_5pzumi_k$('templateSince', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The day this program moved onto the template above. Change it together with the template; earlier days keep whatever paid them.'));
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.addElement_5pzumi_k$('careTime', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Which part of the day this rate pays for. Cannot change once created.'));
        tmp0_serialDesc.addElement_5pzumi_k$('ageStart', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The youngest a child may be in this program. Leave empty for no minimum.'));
        tmp0_serialDesc.addElement_5pzumi_k$('ageEndInclusive', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The age a child stops qualifying for this program, e.g. 2 years for Under 2. Leave empty for no maximum.'));
        tmp0_serialDesc.addElement_5pzumi_k$('availableAsIntermittent', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Whether a school age day can switch to this program when school is out. Only a full or part time program can.'));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['name']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'location', 'template', 'templateSince']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_l2ooix_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_3(), new (ID_1())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (ID())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_0(), new (ID_0())(value.provider_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_5(), new (ID_2())(value.template_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, LocalDateSerializer_getInstance(), value.templateSince_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.active_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 6, value.active_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, tmp2_cached[7].get_value_j01efc_k$(), value.careTime_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.ageStart_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, DatePeriodSerializer_getInstance(), value.ageStart_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.ageEndInclusive_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, DatePeriodSerializer_getInstance(), value.ageEndInclusive_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.availableAsIntermittent_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 10, value.availableAsIntermittent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_l2ooix_k$(encoder, value instanceof CareLocationProgram() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp15_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp16_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp15_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_3();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_0();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_0())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_8 = $serializer_getInstance_5();
          var tmp_9 = tmp8_local4;
          var tmp_10 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (ID_2())(tmp_9));
          tmp8_local4 = tmp_10 == null ? null : tmp_10.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, LocalDateSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp16_cached[7].get_value_j01efc_k$(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, DatePeriodSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, DatePeriodSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_11 = $serializer_getInstance_3();
                var tmp_12 = tmp4_local0;
                var tmp_13 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_11, tmp_12 == null ? null : new (ID_1())(tmp_12));
                tmp4_local0 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_14 = $serializer_getInstance();
                var tmp_15 = tmp5_local1;
                var tmp_16 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_14, tmp_15 == null ? null : new (ID())(tmp_15));
                tmp5_local1 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_17 = $serializer_getInstance_0();
                var tmp_18 = tmp6_local2;
                var tmp_19 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_17, tmp_18 == null ? null : new (ID_0())(tmp_18));
                tmp6_local2 = tmp_19 == null ? null : tmp_19.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_20 = $serializer_getInstance_5();
                var tmp_21 = tmp8_local4;
                var tmp_22 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_20, tmp_21 == null ? null : new (ID_2())(tmp_21));
                tmp8_local4 = tmp_22 == null ? null : tmp_22.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, LocalDateSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, tmp16_cached[7].get_value_j01efc_k$(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, DatePeriodSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, DatePeriodSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp15_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareLocationProgram().new_org_thecommunitygroupinc_cares_CareLocationProgram_f4y8u1_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_3(), $serializer_getInstance(), $serializer_getInstance_0(), StringSerializer_getInstance(), $serializer_getInstance_5(), LocalDateSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[7].get_value_j01efc_k$(), get_nullable(DatePeriodSerializer_getInstance()), get_nullable(DatePeriodSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_4() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var CareLocationProgramClass;
function CareLocationProgram() {
  if (CareLocationProgramClass === VOID) {
    class $ {
      constructor(_id, location, provider, name, template, templateSince, active, careTime, ageStart, ageEndInclusive, availableAsIntermittent) {
        Companion_getInstance_2();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        active = active === VOID ? true : active;
        ageStart = ageStart === VOID ? null : ageStart;
        ageEndInclusive = ageEndInclusive === VOID ? null : ageEndInclusive;
        availableAsIntermittent = availableAsIntermittent === VOID ? false : availableAsIntermittent;
        this._id_1 = _id;
        this.location_1 = location;
        this.provider_1 = provider;
        this.name_1 = name;
        this.template_1 = template;
        this.templateSince_1 = templateSince;
        this.active_1 = active;
        this.careTime_1 = careTime;
        this.ageStart_1 = ageStart;
        this.ageEndInclusive_1 = ageEndInclusive;
        this.availableAsIntermittent_1 = availableAsIntermittent;
        // Inline function 'kotlin.require' call
        if (!(!this.availableAsIntermittent_1 || this.careTime_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, so ' + toString(this.careTime_1) + ' cannot be used for one.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      get__id_a5njik_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_1())(this.get__id_a5njik_k$());
      }
      toString() {
        return 'CareLocationProgram(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', location=' + ID__toString_impl_y5caka(this.location_1) + ', provider=' + ID__toString_impl_y5caka_0(this.provider_1) + ', name=' + this.name_1 + ', template=' + ID__toString_impl_y5caka_2(this.template_1) + ', templateSince=' + this.templateSince_1.toString() + ', active=' + this.active_1 + ', careTime=' + toString(this.careTime_1) + ', ageStart=' + toString_0(this.ageStart_1) + ', ageEndInclusive=' + toString_0(this.ageEndInclusive_1) + ', availableAsIntermittent=' + this.availableAsIntermittent_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.provider_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.template_1) | 0;
        result = imul(result, 31) + this.templateSince_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        result = imul(result, 31) + this.careTime_1.hashCode() | 0;
        result = imul(result, 31) + (this.ageStart_1 == null ? 0 : this.ageStart_1.hashCode()) | 0;
        result = imul(result, 31) + (this.ageEndInclusive_1 == null ? 0 : this.ageEndInclusive_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.availableAsIntermittent_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareLocationProgram()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.template_1, other.template_1))
          return false;
        if (!this.templateSince_1.equals(other.templateSince_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        if (!this.careTime_1.equals(other.careTime_1))
          return false;
        if (!equals(this.ageStart_1, other.ageStart_1))
          return false;
        if (!equals(this.ageEndInclusive_1, other.ageEndInclusive_1))
          return false;
        if (!(this.availableAsIntermittent_1 === other.availableAsIntermittent_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareLocationProgram_f4y8u1_k$(seen0, _id, location, provider, name, template, templateSince, active, careTime, ageStart, ageEndInclusive, availableAsIntermittent, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(190 === (190 & seen0))) {
          throwMissingFieldException(seen0, 190, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.location_1 = location;
        $this.provider_1 = provider;
        $this.name_1 = name;
        $this.template_1 = template;
        $this.templateSince_1 = templateSince;
        if (0 === (seen0 & 64))
          $this.active_1 = true;
        else
          $this.active_1 = active;
        $this.careTime_1 = careTime;
        if (0 === (seen0 & 256))
          $this.ageStart_1 = null;
        else
          $this.ageStart_1 = ageStart;
        if (0 === (seen0 & 512))
          $this.ageEndInclusive_1 = null;
        else
          $this.ageEndInclusive_1 = ageEndInclusive;
        if (0 === (seen0 & 1024))
          $this.availableAsIntermittent_1 = false;
        else
          $this.availableAsIntermittent_1 = availableAsIntermittent;
        // Inline function 'kotlin.require' call
        if (!(!$this.availableAsIntermittent_1 || $this.careTime_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, so ' + toString($this.careTime_1) + ' cannot be used for one.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'CareLocationProgram', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_4});
    CareLocationProgramClass = $;
  }
  return CareLocationProgramClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_2($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareProgramTemplate.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareProgramTemplate())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_52vdq9_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_52vdq9_k$(encoder, value instanceof ID_2() ? value.raw_1 : THROW_CCE());
      }
      deserialize_kjufco_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_2())(this.deserialize_kjufco_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_5() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_2($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_2()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_2())(other instanceof ID_2() ? other.raw_1 : THROW_CCE()));
}
function CareProgramTemplate$Companion$$childSerializers$_anonymous__cj625f() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var IDClass_0;
function ID_2() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_2(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_2(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_5});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, lazy(tmp_0, CareProgramTemplate$Companion$$childSerializers$_anonymous__cj625f), null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProgramTemplate', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('How TCG refers to it, e.g. "Center: Infant (Region 3)".'));
        tmp0_serialDesc.addElement_5pzumi_k$('shortName', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The shorter name of the rate, suggested name for `CareLocationProgram.name`.'));
        tmp0_serialDesc.addElement_5pzumi_k$('careTime', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Which part of the day this rate pays for. Cannot change once created.'));
        tmp0_serialDesc.addElement_5pzumi_k$('ageStart', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The youngest a child may be in this program. Leave empty for no minimum.'));
        tmp0_serialDesc.addElement_5pzumi_k$('ageEndInclusive', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The age a child stops qualifying for this program, e.g. 2 years for Under 2. Leave empty for no maximum.'));
        tmp0_serialDesc.addElement_5pzumi_k$('availableAsIntermittent', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Whether a school age day can switch to this program when school is out. Only a full or part time program can.'));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['~name']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_q2olsq_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_5(), new (ID_2())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.shortName_1 === value.name_1)) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.shortName_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.careTime_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.ageStart_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, DatePeriodSerializer_getInstance(), value.ageStart_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.ageEndInclusive_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, DatePeriodSerializer_getInstance(), value.ageEndInclusive_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.availableAsIntermittent_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 6, value.availableAsIntermittent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_q2olsq_k$(encoder, value instanceof CareProgramTemplate() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_5();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, DatePeriodSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, DatePeriodSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_5();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, DatePeriodSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, DatePeriodSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareProgramTemplate().new_org_thecommunitygroupinc_cares_CareProgramTemplate_670i3f_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_4().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_5(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].get_value_j01efc_k$(), get_nullable(DatePeriodSerializer_getInstance()), get_nullable(DatePeriodSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_6() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var CareProgramTemplateClass;
function CareProgramTemplate() {
  if (CareProgramTemplateClass === VOID) {
    class $ {
      constructor(_id, name, shortName, careTime, ageStart, ageEndInclusive, availableAsIntermittent) {
        Companion_getInstance_4();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        shortName = shortName === VOID ? name : shortName;
        ageStart = ageStart === VOID ? null : ageStart;
        ageEndInclusive = ageEndInclusive === VOID ? null : ageEndInclusive;
        availableAsIntermittent = availableAsIntermittent === VOID ? false : availableAsIntermittent;
        this._id_1 = _id;
        this.name_1 = name;
        this.shortName_1 = shortName;
        this.careTime_1 = careTime;
        this.ageStart_1 = ageStart;
        this.ageEndInclusive_1 = ageEndInclusive;
        this.availableAsIntermittent_1 = availableAsIntermittent;
        // Inline function 'kotlin.require' call
        if (!(!this.availableAsIntermittent_1 || this.careTime_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, so ' + toString(this.careTime_1) + ' cannot be used for one.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      get__id_qk1k3f_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_2())(this.get__id_qk1k3f_k$());
      }
      toString() {
        return 'CareProgramTemplate(_id=' + ID__toString_impl_y5caka_2(this._id_1) + ', name=' + this.name_1 + ', shortName=' + this.shortName_1 + ', careTime=' + toString(this.careTime_1) + ', ageStart=' + toString_0(this.ageStart_1) + ', ageEndInclusive=' + toString_0(this.ageEndInclusive_1) + ', availableAsIntermittent=' + this.availableAsIntermittent_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.shortName_1) | 0;
        result = imul(result, 31) + this.careTime_1.hashCode() | 0;
        result = imul(result, 31) + (this.ageStart_1 == null ? 0 : this.ageStart_1.hashCode()) | 0;
        result = imul(result, 31) + (this.ageEndInclusive_1 == null ? 0 : this.ageEndInclusive_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.availableAsIntermittent_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareProgramTemplate()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.shortName_1 === other.shortName_1))
          return false;
        if (!this.careTime_1.equals(other.careTime_1))
          return false;
        if (!equals(this.ageStart_1, other.ageStart_1))
          return false;
        if (!equals(this.ageEndInclusive_1, other.ageEndInclusive_1))
          return false;
        if (!(this.availableAsIntermittent_1 === other.availableAsIntermittent_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProgramTemplate_670i3f_k$(seen0, _id, name, shortName, careTime, ageStart, ageEndInclusive, availableAsIntermittent, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.name_1 = name;
        if (0 === (seen0 & 4))
          $this.shortName_1 = $this.name_1;
        else
          $this.shortName_1 = shortName;
        $this.careTime_1 = careTime;
        if (0 === (seen0 & 16))
          $this.ageStart_1 = null;
        else
          $this.ageStart_1 = ageStart;
        if (0 === (seen0 & 32))
          $this.ageEndInclusive_1 = null;
        else
          $this.ageEndInclusive_1 = ageEndInclusive;
        if (0 === (seen0 & 64))
          $this.availableAsIntermittent_1 = false;
        else
          $this.availableAsIntermittent_1 = availableAsIntermittent;
        // Inline function 'kotlin.require' call
        if (!(!$this.availableAsIntermittent_1 || $this.careTime_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, so ' + toString($this.careTime_1) + ' cannot be used for one.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'CareProgramTemplate', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_6});
    CareProgramTemplateClass = $;
  }
  return CareProgramTemplateClass;
}
function _ID___init__impl__k1lb7e_1(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_1($this) {
  return $this;
}
function ID__toString_impl_y5caka_3($this) {
  return _ID___get_raw__impl__92g6u5_1($this).toString();
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareLocationProgramDated.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareLocationProgramDated())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_312k2k_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_1(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_312k2k_k$(encoder, value instanceof ID_3() ? value.raw_1 : THROW_CCE());
      }
      deserialize_8w27px_k$(decoder) {
        return _ID___init__impl__k1lb7e_1(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_3())(this.deserialize_8w27px_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_7() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function ID__hashCode_impl_f4lulz_3($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_1($this, other) {
  if (!(other instanceof ID_3()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_1($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_3())(other instanceof ID_3() ? other.raw_1 : THROW_CCE()));
}
var IDClass_1;
function ID_3() {
  if (IDClass_1 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_1(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_3(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_3(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_1(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_7});
    IDClass_1 = $;
  }
  return IDClass_1;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareLocationProgramDated', this, 11);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('program', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('template', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Denormalized())());
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('templateDated', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The revision of the template these rates come from.'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The days these rates apply to. Leave the end open and they run until a later row supersedes them.'));
        tmp0_serialDesc.addElement_5pzumi_k$('price', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportOneWay', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTwoWay', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['name', 'activeRange.start']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['name', 'activeRange.start', 'location', 'template']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_vj4yin_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_7(), new (ID_3())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_3(), new (ID_1())(value.program_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance(), new (ID())(value.location_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_0(), new (ID_0())(value.provider_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_5(), new (ID_2())(value.template_1));
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, $serializer_getInstance_9(), new (ID_4())(value.templateDated_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, $serializer_getInstance_1(), value.activeRange_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, $serializer_getInstance_2(), new (Cents())(value.price_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.transportOneWay_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, $serializer_getInstance_2(), new (Cents())(value.transportOneWay_1));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.transportTwoWay_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 10, $serializer_getInstance_2(), new (Cents())(value.transportTwoWay_1));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vj4yin_k$(encoder, value instanceof CareLocationProgramDated() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp15_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_7();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_3();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_1())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_8 = $serializer_getInstance_0();
          var tmp_9 = tmp7_local3;
          var tmp_10 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (ID_0())(tmp_9));
          tmp7_local3 = tmp_10 == null ? null : tmp_10.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_11 = $serializer_getInstance_5();
          var tmp_12 = tmp8_local4;
          var tmp_13 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_11, tmp_12 == null ? null : new (ID_2())(tmp_12));
          tmp8_local4 = tmp_13 == null ? null : tmp_13.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_14 = $serializer_getInstance_9();
          var tmp_15 = tmp10_local6;
          var tmp_16 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_14, tmp_15 == null ? null : new (ID_4())(tmp_15));
          tmp10_local6 = tmp_16 == null ? null : tmp_16.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_1(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_17 = $serializer_getInstance_2();
          var tmp_18 = tmp12_local8;
          var tmp_19 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp_17, tmp_18 == null ? null : new (Cents())(tmp_18));
          tmp12_local8 = tmp_19 == null ? null : tmp_19.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          var tmp_20 = $serializer_getInstance_2();
          var tmp_21 = tmp13_local9;
          var tmp_22 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp_20, tmp_21 == null ? null : new (Cents())(tmp_21));
          tmp13_local9 = tmp_22 == null ? null : tmp_22.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_23 = $serializer_getInstance_2();
          var tmp_24 = tmp14_local10;
          var tmp_25 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, tmp_23, tmp_24 == null ? null : new (Cents())(tmp_24));
          tmp14_local10 = tmp_25 == null ? null : tmp_25.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_26 = $serializer_getInstance_7();
                var tmp_27 = tmp4_local0;
                var tmp_28 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_26, tmp_27 == null ? null : new (ID_3())(tmp_27));
                tmp4_local0 = tmp_28 == null ? null : tmp_28.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_29 = $serializer_getInstance_3();
                var tmp_30 = tmp5_local1;
                var tmp_31 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_29, tmp_30 == null ? null : new (ID_1())(tmp_30));
                tmp5_local1 = tmp_31 == null ? null : tmp_31.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_32 = $serializer_getInstance();
                var tmp_33 = tmp6_local2;
                var tmp_34 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_32, tmp_33 == null ? null : new (ID())(tmp_33));
                tmp6_local2 = tmp_34 == null ? null : tmp_34.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_35 = $serializer_getInstance_0();
                var tmp_36 = tmp7_local3;
                var tmp_37 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_35, tmp_36 == null ? null : new (ID_0())(tmp_36));
                tmp7_local3 = tmp_37 == null ? null : tmp_37.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_38 = $serializer_getInstance_5();
                var tmp_39 = tmp8_local4;
                var tmp_40 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_38, tmp_39 == null ? null : new (ID_2())(tmp_39));
                tmp8_local4 = tmp_40 == null ? null : tmp_40.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_41 = $serializer_getInstance_9();
                var tmp_42 = tmp10_local6;
                var tmp_43 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_41, tmp_42 == null ? null : new (ID_4())(tmp_42));
                tmp10_local6 = tmp_43 == null ? null : tmp_43.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_1(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_44 = $serializer_getInstance_2();
                var tmp_45 = tmp12_local8;
                var tmp_46 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp_44, tmp_45 == null ? null : new (Cents())(tmp_45));
                tmp12_local8 = tmp_46 == null ? null : tmp_46.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                var tmp_47 = $serializer_getInstance_2();
                var tmp_48 = tmp13_local9;
                var tmp_49 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, tmp_47, tmp_48 == null ? null : new (Cents())(tmp_48));
                tmp13_local9 = tmp_49 == null ? null : tmp_49.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_50 = $serializer_getInstance_2();
                var tmp_51 = tmp14_local10;
                var tmp_52 = tmp15_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 10, tmp_50, tmp_51 == null ? null : new (Cents())(tmp_51));
                tmp14_local10 = tmp_52 == null ? null : tmp_52.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp15_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareLocationProgramDated().new_org_thecommunitygroupinc_cares_CareLocationProgramDated_rd2il3_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_7(), $serializer_getInstance_3(), $serializer_getInstance(), $serializer_getInstance_0(), $serializer_getInstance_5(), StringSerializer_getInstance(), $serializer_getInstance_9(), $serializer_getInstance_1(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_8() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CareLocationProgramDatedClass;
function CareLocationProgramDated() {
  if (CareLocationProgramDatedClass === VOID) {
    class $ {
      constructor(_id, program, location, provider, template, name, templateDated, activeRange, price, transportOneWay, transportTwoWay) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        transportOneWay = transportOneWay === VOID ? Companion_instance.get_cents_3bbzqx_k$(0) : transportOneWay;
        transportTwoWay = transportTwoWay === VOID ? Companion_instance.get_cents_3bbzqx_k$(0) : transportTwoWay;
        this._id_1 = _id;
        this.program_1 = program;
        this.location_1 = location;
        this.provider_1 = provider;
        this.template_1 = template;
        this.name_1 = name;
        this.templateDated_1 = templateDated;
        this.activeRange_1 = activeRange;
        this.price_1 = price;
        this.transportOneWay_1 = transportOneWay;
        this.transportTwoWay_1 = transportTwoWay;
      }
      get__id_2295w8_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_3())(this.get__id_2295w8_k$());
      }
      toString() {
        return 'CareLocationProgramDated(_id=' + ID__toString_impl_y5caka_3(this._id_1) + ', program=' + ID__toString_impl_y5caka_1(this.program_1) + ', location=' + ID__toString_impl_y5caka(this.location_1) + ', provider=' + ID__toString_impl_y5caka_0(this.provider_1) + ', template=' + ID__toString_impl_y5caka_2(this.template_1) + ', name=' + this.name_1 + ', templateDated=' + ID__toString_impl_y5caka_4(this.templateDated_1) + ', activeRange=' + this.activeRange_1.toString() + ', price=' + Cents__toString_impl_ko5hxm(this.price_1) + ', transportOneWay=' + Cents__toString_impl_ko5hxm(this.transportOneWay_1) + ', transportTwoWay=' + Cents__toString_impl_ko5hxm(this.transportTwoWay_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_1(this.program_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz(this.location_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.provider_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.template_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_4(this.templateDated_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.price_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.transportOneWay_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.transportTwoWay_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareLocationProgramDated()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.program_1, other.program_1))
          return false;
        if (!equals(this.location_1, other.location_1))
          return false;
        if (!equals(this.provider_1, other.provider_1))
          return false;
        if (!equals(this.template_1, other.template_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.templateDated_1, other.templateDated_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!(this.price_1 === other.price_1))
          return false;
        if (!(this.transportOneWay_1 === other.transportOneWay_1))
          return false;
        if (!(this.transportTwoWay_1 === other.transportTwoWay_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareLocationProgramDated_rd2il3_k$(seen0, _id, program, location, provider, template, name, templateDated, activeRange, price, transportOneWay, transportTwoWay, serializationConstructorMarker) {
        if (!(510 === (510 & seen0))) {
          throwMissingFieldException(seen0, 510, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.program_1 = program;
        $this.location_1 = location;
        $this.provider_1 = provider;
        $this.template_1 = template;
        $this.name_1 = name;
        $this.templateDated_1 = templateDated;
        $this.activeRange_1 = activeRange;
        $this.price_1 = price;
        if (0 === (seen0 & 512))
          $this.transportOneWay_1 = Companion_instance.get_cents_3bbzqx_k$(0);
        else
          $this.transportOneWay_1 = transportOneWay;
        if (0 === (seen0 & 1024))
          $this.transportTwoWay_1 = Companion_instance.get_cents_3bbzqx_k$(0);
        else
          $this.transportTwoWay_1 = transportTwoWay;
        return $this;
      }
    }
    initMetadataForClass($, 'CareLocationProgramDated', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_8});
    CareLocationProgramDatedClass = $;
  }
  return CareLocationProgramDatedClass;
}
function _ID___init__impl__k1lb7e_2(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_2($this) {
  return $this;
}
function ID__toString_impl_y5caka_4($this) {
  return _ID___get_raw__impl__92g6u5_2($this).toString();
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.CareProgramTemplateDated.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(CareProgramTemplateDated())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ecinvx_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_2(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ecinvx_k$(encoder, value instanceof ID_4() ? value.raw_1 : THROW_CCE());
      }
      deserialize_h871d0_k$(decoder) {
        return _ID___init__impl__k1lb7e_2(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_4())(this.deserialize_h871d0_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_9() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function ID__hashCode_impl_f4lulz_4($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_2($this, other) {
  if (!(other instanceof ID_4()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_2($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_4())(other instanceof ID_4() ? other.raw_1 : THROW_CCE()));
}
var IDClass_2;
function ID_4() {
  if (IDClass_2 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_2(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_4(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_4(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_2(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_2(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_9});
    IDClass_2 = $;
  }
  return IDClass_2;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  return Companion_instance_7;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareProgramTemplateDated', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('template', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('activeRange', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The days this revision applies to. Leave the end open and it runs until a later revision supersedes it.'));
        tmp0_serialDesc.addElement_5pzumi_k$('price', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportOneWay', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTwoWay', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['template', 'activeRange.start']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['activeRange.start', 'template']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-activeRange.start']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_1t3jn2_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_9(), new (ID_4())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_5(), new (ID_2())(value.template_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_1(), value.activeRange_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_2(), new (Cents())(value.price_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.transportOneWay_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_getInstance_2(), new (Cents())(value.transportOneWay_1));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.transportTwoWay_1 === Companion_instance.get_cents_3bbzqx_k$(0))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_2(), new (Cents())(value.transportTwoWay_1));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1t3jn2_k$(encoder, value instanceof CareProgramTemplateDated() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_9();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_4())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_5();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp7_local3;
          var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (Cents())(tmp_6));
          tmp7_local3 = tmp_7 == null ? null : tmp_7.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_8 = $serializer_getInstance_2();
          var tmp_9 = tmp8_local4;
          var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (Cents())(tmp_9));
          tmp8_local4 = tmp_10 == null ? null : tmp_10.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_11 = $serializer_getInstance_2();
          var tmp_12 = tmp9_local5;
          var tmp_13 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (Cents())(tmp_12));
          tmp9_local5 = tmp_13 == null ? null : tmp_13.inCents_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_14 = $serializer_getInstance_9();
                var tmp_15 = tmp4_local0;
                var tmp_16 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_14, tmp_15 == null ? null : new (ID_4())(tmp_15));
                tmp4_local0 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_17 = $serializer_getInstance_5();
                var tmp_18 = tmp5_local1;
                var tmp_19 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_17, tmp_18 == null ? null : new (ID_2())(tmp_18));
                tmp5_local1 = tmp_19 == null ? null : tmp_19.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_20 = $serializer_getInstance_2();
                var tmp_21 = tmp7_local3;
                var tmp_22 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_20, tmp_21 == null ? null : new (Cents())(tmp_21));
                tmp7_local3 = tmp_22 == null ? null : tmp_22.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_23 = $serializer_getInstance_2();
                var tmp_24 = tmp8_local4;
                var tmp_25 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp_23, tmp_24 == null ? null : new (Cents())(tmp_24));
                tmp8_local4 = tmp_25 == null ? null : tmp_25.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_26 = $serializer_getInstance_2();
                var tmp_27 = tmp9_local5;
                var tmp_28 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp_26, tmp_27 == null ? null : new (Cents())(tmp_27));
                tmp9_local5 = tmp_28 == null ? null : tmp_28.inCents_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareProgramTemplateDated().new_org_thecommunitygroupinc_cares_CareProgramTemplateDated_1m8la9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_9(), $serializer_getInstance_5(), $serializer_getInstance_1(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_10() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var CareProgramTemplateDatedClass;
function CareProgramTemplateDated() {
  if (CareProgramTemplateDatedClass === VOID) {
    class $ {
      constructor(_id, template, activeRange, price, transportOneWay, transportTwoWay) {
        _id = _id === VOID ? _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        transportOneWay = transportOneWay === VOID ? Companion_instance.get_cents_3bbzqx_k$(0) : transportOneWay;
        transportTwoWay = transportTwoWay === VOID ? Companion_instance.get_cents_3bbzqx_k$(0) : transportTwoWay;
        this._id_1 = _id;
        this.template_1 = template;
        this.activeRange_1 = activeRange;
        this.price_1 = price;
        this.transportOneWay_1 = transportOneWay;
        this.transportTwoWay_1 = transportTwoWay;
      }
      get__id_69vnqv_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_4())(this.get__id_69vnqv_k$());
      }
      copy_8skt99_k$(_id, template, activeRange, price, transportOneWay, transportTwoWay) {
        return new (CareProgramTemplateDated())(_id, template, activeRange, price, transportOneWay, transportTwoWay);
      }
      copy$default_7ear6o_k$(_id, template, activeRange, price, transportOneWay, transportTwoWay, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        template = template === VOID ? this.template_1 : template;
        activeRange = activeRange === VOID ? this.activeRange_1 : activeRange;
        price = price === VOID ? this.price_1 : price;
        transportOneWay = transportOneWay === VOID ? this.transportOneWay_1 : transportOneWay;
        transportTwoWay = transportTwoWay === VOID ? this.transportTwoWay_1 : transportTwoWay;
        return $super === VOID ? this.copy_8skt99_k$(_id, template, activeRange, price, transportOneWay, transportTwoWay) : $super.copy_8skt99_k$.call(this, new (ID_4())(_id), new (ID_2())(template), activeRange, new (Cents())(price), new (Cents())(transportOneWay), new (Cents())(transportTwoWay));
      }
      toString() {
        return 'CareProgramTemplateDated(_id=' + ID__toString_impl_y5caka_4(this._id_1) + ', template=' + ID__toString_impl_y5caka_2(this.template_1) + ', activeRange=' + this.activeRange_1.toString() + ', price=' + Cents__toString_impl_ko5hxm(this.price_1) + ', transportOneWay=' + Cents__toString_impl_ko5hxm(this.transportOneWay_1) + ', transportTwoWay=' + Cents__toString_impl_ko5hxm(this.transportTwoWay_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_4(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_2(this.template_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.price_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.transportOneWay_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.transportTwoWay_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareProgramTemplateDated()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.template_1, other.template_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        if (!(this.price_1 === other.price_1))
          return false;
        if (!(this.transportOneWay_1 === other.transportOneWay_1))
          return false;
        if (!(this.transportTwoWay_1 === other.transportTwoWay_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareProgramTemplateDated_1m8la9_k$(seen0, _id, template, activeRange, price, transportOneWay, transportTwoWay, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_10().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.template_1 = template;
        $this.activeRange_1 = activeRange;
        $this.price_1 = price;
        if (0 === (seen0 & 16))
          $this.transportOneWay_1 = Companion_instance.get_cents_3bbzqx_k$(0);
        else
          $this.transportOneWay_1 = transportOneWay;
        if (0 === (seen0 & 32))
          $this.transportTwoWay_1 = Companion_instance.get_cents_3bbzqx_k$(0);
        else
          $this.transportTwoWay_1 = transportTwoWay;
        return $this;
      }
    }
    initMetadataForClass($, 'CareProgramTemplateDated', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_10});
    CareProgramTemplateDatedClass = $;
  }
  return CareProgramTemplateDatedClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_4 = new (Companion_3())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
//endregion
//region block: exports
export {
  ID__hashCode_impl_f4lulz_1 as ID__hashCode_impl_f4lulz1p7uxb6gqsw7j,
  ID__toString_impl_y5caka_1 as ID__toString_impl_y5caka1p73pxlcdvne,
  Companion_getInstance_2 as Companion_getInstance3rx4dbijulyuv,
  $serializer_getInstance_3 as $serializer_getInstance38surg0wl5xyc,
  Companion_instance_0 as Companion_instance1tbwufhoxgh91,
  Companion_instance_5 as Companion_instancesqd80ja9ulcs,
  Companion_instance_4 as Companion_instance31cl4jss4rew2,
  Companion_getInstance_4 as Companion_getInstanceyrbofvk90ue2,
  Companion_instance_2 as Companion_instance1yqwk60hvo8wt,
  Companion_instance_7 as Companion_instance2km53rz6tjv2o,
  Companion_instance_6 as Companion_instance6mmlcn2whvbb,
  ID_1 as ID3lnbkn76l7dgd,
  ID_3 as ID1lpgwt2us7em9,
  CareLocationProgramDated as CareLocationProgramDated2hjmsy0f9azw0,
  CareLocationProgram as CareLocationProgrameuu05ugy00sb,
  ID_2 as ID3j2ictjlq95nd,
  CareProgramTemplateDated as CareProgramTemplateDated1lvcdu3xhc5up,
  CareProgramTemplate as CareProgramTemplatemobjbqq2s74k,
};
//endregion

//# sourceMappingURL=careRates.mjs.map
